"use client";

import { c as _c } from "react/compiler-runtime";
import Image, { type StaticImageData } from "next/image";
import { usePathname } from "next/navigation";
import { useState } from "react";
import { ButtonRadialFill } from "@/components/button-radial-fill";
import MenuDropdown from "@/components/menu-dropdown";
import { usePageTransition } from "@/components/page-transition-provider";
import { TransitionLink } from "@/components/transition-link";
import { type NavItem, servicesNavItem, servicesNavLinks } from "@/layouts/nav-items";
import Bg_Dots from "~/public/assets/backgrounds/bg-dots.png";
import Bg_Section from "~/public/assets/backgrounds/bg-section-bottom.png";
import FlowFooter from "~/public/assets/flow-footer.png";
import Logo from "~/public/assets/logo-flow.png";
import Instagram from "~/public/assets/socials/icon-instagram.png";
import Linkedin from "~/public/assets/socials/icon-linkedin.png";
const navItems: NavItem[] = [{
  label: "Home",
  href: "/"
}, servicesNavItem, {
  label: "Cases",
  href: "/portfolio"
}, {
  label: "Sobre",
  href: "/sobre"
}, {
  label: "Blog",
  href: "/blog"
}, {
  label: "Contato",
  href: "/contato"
}];
type SocialItem = {
  label: string;
  href: string;
  icon: StaticImageData;
};
const socialItems: SocialItem[] = [{
  label: "Instagram",
  href: "https://www.instagram.com/flowlabtech/",
  icon: Instagram
}, {
  label: "LinkedIn",
  href: "https://www.linkedin.com/company/flowlabtech/",
  icon: Linkedin
}];
export function Footer() {
  const $ = _c(82);
  const {
    navigate
  } = usePageTransition();
  const [openPopover, setOpenPopover] = useState(null);
  const pathname = usePathname();
  const isIaFirst = pathname === "/servicos/ia-first";
  const isSolutionsPage = pathname === "/servicos/modernizacao-de-sistemas-legados";
  let t0;
  if ($[0] !== isSolutionsPage || $[1] !== pathname) {
    t0 = pathname.startsWith("/servicos") && !isSolutionsPage;
    $[0] = isSolutionsPage;
    $[1] = pathname;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const isServicesPage = t0;
  const isThankYouPage = pathname === "/solicitacao-de-proposta-enviada" || pathname === "/contato-enviado";
  const hasOwnCta = isServicesPage || pathname === "/contato";
  const hideCtaSection = isThankYouPage || hasOwnCta;
  let t1;
  if ($[3] !== pathname) {
    t1 = href => href.startsWith("/#") && pathname === "/" ? href.replace("/", "") : href;
    $[3] = pathname;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const resolveHref = t1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[5] !== hasOwnCta || $[6] !== hideCtaSection || $[7] !== isIaFirst || $[8] !== isServicesPage || $[9] !== isSolutionsPage || $[10] !== navigate || $[11] !== resolveHref) {
    const primaryNavItems = navItems.filter(_temp);
    t12 = "defer-render md:container-padding relative bg-gray-1100 text-white";
    t13 = "contato";
    if ($[26] !== hideCtaSection) {
      t14 = !hideCtaSection && <><Image src={Bg_Dots} alt="Background decorativo" aria-hidden="true" className="pointer-events-none absolute top-0 right-0 z-20 h-full w-full max-h-60 max-w-90 object-cover will-change-transform md:bottom-0 md:max-h-135 md:max-w-144.5 max-md:scale-y-[-1]!" width={3000} height={3000} /><div className="pointer-events-none absolute inset-0 overflow-hidden"><div className="absolute -top-24 -right-20 z-10 h-full w-full max-h-70 max-w-40 rounded-full bg-[linear-gradient(168.76deg,#2A0502_15.35%,#A43A1C_52.46%,#FF8C31_67.94%)] opacity-90 blur-[90px] md:-top-30 md:-right-50 md:max-h-80 md:max-w-160 md:blur-[180px]" /></div></>;
      $[26] = hideCtaSection;
      $[27] = t14;
    } else {
      t14 = $[27];
    }
    if ($[28] !== hideCtaSection || $[29] !== isIaFirst || $[30] !== isServicesPage || $[31] !== isSolutionsPage || $[32] !== navigate) {
      t15 = !hideCtaSection && <section className="lg:relative border-b border-gray-300/80"><div className="container relative mx-auto px-6 lg:px-18 pt-44 pb-28"><div className={`relative z-50 max-w-110
								${isIaFirst ? "lg:max-w-140" : isServicesPage ? "xl:max-w-120" : " xl:max-w-150"}`}><p className="tag mb-2.5">Seu próximo passo</p><h2 className={`text-4xl font-medium text-white whitespace-pre-line
							${!isIaFirst && !isServicesPage && !isSolutionsPage && "xl:max-w-100"}`}>{isIaFirst ? "IA do seu concorrente j\xE1 est\xE1 em produ\xE7\xE3o. E a sua opera\xE7\xE3o?" : isServicesPage ? "Seu produto merece uma experi\xEAncia melhor." : isSolutionsPage ? "Tecnologia evolui. \nNeg\xF3cios n\xE3o podem parar." : "Vamos conversar sobre seu projeto?"}</h2><p className="mt-5 text-xl leading-[160%] text-gray-400 max-sm:text-base">{isIaFirst ? "Em 30 minutos: mapeamos seu caso, propomos a arquitetura e estimamos o prazo. Sem enrola\xE7\xE3o." : isServicesPage ? "Vamos transformar sua ideia em uma interface clara, moderna e preparada para crescer." : isSolutionsPage ? "Descubra como modernizar seus sistemas sem recome\xE7ar do zero e sem comprometer a opera\xE7\xE3o." : "Um produto para evoluir, um processo para melhorar ou uma ideia para validar, te ajudamos a encontrar o melhor caminho."}</p><div className="mt-11 flex gap-4">{isIaFirst || isSolutionsPage ? <ButtonRadialFill className="h-14.5 px-6 rounded-2xl border border-primary-300 bg-primary-300" classNameFill="bg-gray-1100" onClick={event => {
                navigate("/contato", {
                  origin: {
                    x: event.clientX,
                    y: event.clientY
                  }
                });
              }}>Agendar diagnóstico</ButtonRadialFill> : <ButtonRadialFill className="h-14.5 px-6 rounded-2xl border border-primary-300 bg-primary-300" classNameFill="bg-gray-1100" onClick={event_0 => {
                navigate("/contato", {
                  origin: {
                    x: event_0.clientX,
                    y: event_0.clientY
                  }
                });
              }}>Fale com o nosso time</ButtonRadialFill>}</div></div><div className="pointer-events-none absolute top-5 -right-30 z-40 flex items-center justify-end md:inset-y-0 md:-right-10"><Image src={FlowFooter} alt="" aria-hidden="true" className="w-full max-sm:min-w-60 max-sm:max-w-90 min-w-100 max-w-140 max-2xl:max-w-130" height={1814} priority={false} width={2016} /></div></div></section>;
      $[28] = hideCtaSection;
      $[29] = isIaFirst;
      $[30] = isServicesPage;
      $[31] = isSolutionsPage;
      $[32] = navigate;
      $[33] = t15;
    } else {
      t15 = $[33];
    }
    t10 = `relative overflow-visible bg-gray-1100
					${hasOwnCta ? "border-t border-gray-300/80" : ""}`;
    if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = <div className="pointer-events-none absolute inset-x-0 bottom-0 h-full bg-[linear-gradient(180deg,#080808_0%,rgba(18,18,18,0.84)_100%)]" />;
      $[34] = t11;
    } else {
      t11 = $[34];
    }
    t9 = "container relative mx-auto px-6 lg:px-18 py-10 pb-14 lg:pb-20";
    t8 = "flex max-lg:flex-col items-center justify-between gap-8";
    t7 = "w-full";
    t5 = "Navega\xE7\xE3o principal mobile";
    t6 = "md:hidden";
    t4 = "flex gap-x-30 gap-y-4 mx-auto justify-center";
    t2 = "flex flex-col items-start gap-4";
    let t16;
    if ($[35] !== resolveHref) {
      t16 = item_0 => <TransitionLink href={resolveHref(item_0.href)} key={item_0.label} className="text-[15px] text-white/80 transition hover:text-white focus:text-white">{item_0.label}</TransitionLink>;
      $[35] = resolveHref;
      $[36] = t16;
    } else {
      t16 = $[36];
    }
    t3 = primaryNavItems.map(t16);
    $[5] = hasOwnCta;
    $[6] = hideCtaSection;
    $[7] = isIaFirst;
    $[8] = isServicesPage;
    $[9] = isSolutionsPage;
    $[10] = navigate;
    $[11] = resolveHref;
    $[12] = t10;
    $[13] = t11;
    $[14] = t12;
    $[15] = t13;
    $[16] = t14;
    $[17] = t15;
    $[18] = t2;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
  } else {
    t10 = $[12];
    t11 = $[13];
    t12 = $[14];
    t13 = $[15];
    t14 = $[16];
    t15 = $[17];
    t2 = $[18];
    t3 = $[19];
    t4 = $[20];
    t5 = $[21];
    t6 = $[22];
    t7 = $[23];
    t8 = $[24];
    t9 = $[25];
  }
  let t16;
  if ($[37] !== t2 || $[38] !== t3) {
    t16 = <div className={t2}>{t3}</div>;
    $[37] = t2;
    $[38] = t3;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  let t17;
  if ($[40] !== resolveHref) {
    t17 = servicesNavLinks.map(item_1 => <TransitionLink href={resolveHref(item_1.href)} key={item_1.label} className="text-[15px] text-white/80 transition hover:text-white focus:text-white">{item_1.label}</TransitionLink>);
    $[40] = resolveHref;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== t17) {
    t18 = <div className="flex flex-col items-start gap-4">{t17}</div>;
    $[42] = t17;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] !== t16 || $[45] !== t18 || $[46] !== t4) {
    t19 = <div className={t4}>{t16}{t18}</div>;
    $[44] = t16;
    $[45] = t18;
    $[46] = t4;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  let t20;
  if ($[48] !== t19 || $[49] !== t5 || $[50] !== t6) {
    t20 = <nav aria-label={t5} className={t6}>{t19}</nav>;
    $[48] = t19;
    $[49] = t5;
    $[50] = t6;
    $[51] = t20;
  } else {
    t20 = $[51];
  }
  let t21;
  if ($[52] !== openPopover || $[53] !== resolveHref) {
    t21 = navItems.map(item_2 => <div key={item_2.label} className="relative">{item_2.groups ? <li key={item_2.label} className="relative"><MenuDropdown isFooter={true} item={item_2} openPopover={openPopover} setOpenPopover={setOpenPopover} /></li> : <TransitionLink href={resolveHref(item_2.href)} className="rounded-full px-4 py-3 text-[15px] text-white/80 hover:bg-white/5 hover:text-white focus:bg-white/5 focus:text-white">{item_2.label}</TransitionLink>}</div>);
    $[52] = openPopover;
    $[53] = resolveHref;
    $[54] = t21;
  } else {
    t21 = $[54];
  }
  let t22;
  if ($[55] !== t21) {
    t22 = <nav aria-label={"Navega\xE7\xE3o principal"} className="hidden md:flex items-center justify-between gap-8"><ul className="flex items-center gap-5 lg:gap-10 max-sm:flex-col">{t21}</ul></nav>;
    $[55] = t21;
    $[56] = t22;
  } else {
    t22 = $[56];
  }
  let t23;
  if ($[57] !== t20 || $[58] !== t22 || $[59] !== t7) {
    t23 = <div className={t7}>{t20}{t22}</div>;
    $[57] = t20;
    $[58] = t22;
    $[59] = t7;
    $[60] = t23;
  } else {
    t23 = $[60];
  }
  let t24;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <div className="items-center gap-3 hidden md:flex">{socialItems.map(_temp2)}</div>;
    $[61] = t24;
  } else {
    t24 = $[61];
  }
  let t25;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <div className="flex items-center gap-3 mt-5 md:hidden">{socialItems.map(_temp3)}</div>;
    $[62] = t25;
  } else {
    t25 = $[62];
  }
  let t26;
  if ($[63] !== t23 || $[64] !== t8) {
    t26 = <div className={t8}>{t23}{t24}{t25}</div>;
    $[63] = t23;
    $[64] = t8;
    $[65] = t26;
  } else {
    t26 = $[65];
  }
  let t27;
  if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <TransitionLink href="/" aria-label="Flowlab Tech"><Image src={Logo} alt="" aria-hidden="true" className="w-full max-w-46.25 md:max-w-28" width={495} height={81} loading="lazy" /></TransitionLink>;
    $[66] = t27;
  } else {
    t27 = $[66];
  }
  let t28;
  if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <div className="mt-14 lg:mt-20 flex items-center justify-between gap-4 max-md:flex-row-reverse">{t27}<p className="md:text-center text-xs md:text-sm font-light text-white whitespace-nowrap">Copyright © FlowLab 2016 - {new Date().getFullYear()}</p></div>;
    $[67] = t28;
  } else {
    t28 = $[67];
  }
  let t29;
  if ($[68] !== t26 || $[69] !== t9) {
    t29 = <div className={t9}>{t26}{t28}</div>;
    $[68] = t26;
    $[69] = t9;
    $[70] = t29;
  } else {
    t29 = $[70];
  }
  let t30;
  if ($[71] !== t10 || $[72] !== t11 || $[73] !== t29) {
    t30 = <section className={t10}>{t11}{t29}</section>;
    $[71] = t10;
    $[72] = t11;
    $[73] = t29;
    $[74] = t30;
  } else {
    t30 = $[74];
  }
  let t31;
  if ($[75] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <Image src={Bg_Section} alt="Background decorativo" className="absolute w-full h-full object-cover -bottom-14! pointer-events-none" priority={false} sizes="100vw" />;
    $[75] = t31;
  } else {
    t31 = $[75];
  }
  let t32;
  if ($[76] !== t12 || $[77] !== t13 || $[78] !== t14 || $[79] !== t15 || $[80] !== t30) {
    t32 = <footer className={t12} id={t13}>{t14}{t15}{t30}{t31}</footer>;
    $[76] = t12;
    $[77] = t13;
    $[78] = t14;
    $[79] = t15;
    $[80] = t30;
    $[81] = t32;
  } else {
    t32 = $[81];
  }
  return t32;
}
function _temp3(t0) {
  const {
    href: href_1,
    icon: icon_0,
    label: label_0
  } = t0;
  return <a aria-label={label_0} className="transition-all duration-300 ease-in-out hover:scale-110" href={href_1} key={label_0}><Image src={icon_0} className="w-full max-w-8" alt={label_0} height={100} width={100} /></a>;
}
function _temp2(t0) {
  const {
    href: href_0,
    icon,
    label
  } = t0;
  return <a aria-label={label} className="transition-all duration-300 ease-in-out hover:scale-110" href={href_0} key={label}><Image src={icon} className="w-full max-w-8" alt={label} height={100} width={100} /></a>;
}
function _temp(item) {
  return !item.groups;
}